module.exports = __webpack_public_path__ + "494cd07c/img/delete-icon.eb7de062.svg";